import { useEffect, useMemo } from "react";
import { lock, removeTokenByKey, setToken, unlock } from "./AuthTokenStorage";
var clearTokens = function () {
  removeTokenByKey("accessToken"), removeTokenByKey("idToken");
};
export var useAuthStorage = function (tokens) {
  var isInCharge = useMemo(function () {
    return lock();
  }, []);
  useEffect(function () {
    isInCharge && (tokens ? (setToken("accessToken", tokens.accessToken), setToken("idToken", tokens.idToken)) : clearTokens());
  }, [isInCharge, tokens]), useEffect(function () {
    if (isInCharge) return function () {
      unlock(), clearTokens();
    };
  }, [isInCharge]);
};